import { useMemo } from 'react';
import { ReaderChapter } from '@/services/booksApi';

export interface ChapterTreeNode {
  chapter: ReaderChapter;
  children: ChapterTreeNode[];
}

export const useChapterTree = (chapters: ReaderChapter[]): ChapterTreeNode[] => {
  return useMemo(() => {
    const nodeById = new Map<string, ChapterTreeNode>();
    const roots: ChapterTreeNode[] = [];

    chapters.forEach((chapter) => {
      nodeById.set(chapter.id, {
        chapter,
        children: [],
      });
    });

    chapters.forEach((chapter) => {
      const node = nodeById.get(chapter.id);
      if (!node) {
        return;
      }

      if (!chapter.parentId) {
        roots.push(node);
        return;
      }

      const parent = nodeById.get(chapter.parentId);
      if (!parent) {
        // Orphan chapters are promoted to root level.
        roots.push(node);
        return;
      }

      parent.children.push(node);
    });

    return roots;
  }, [chapters]);
};
